/* eslint-disable no-unused-vars */
import styles from '../MessageList.module.scss';
import { Button } from 'tt-ui-lib/core';

export const SendAudioMessageBtn = (props) => {
  const { ...restProps } = props;
  return (
    <>
      <Button {...restProps} className={styles.bottomButton} type="icon">
        <img src="/images/chat/mic-icon.svg" alt="" style={{ width: 18, height: 24 }} />
      </Button>
    </>
  );
};
